import React from 'react'
import { useTranslation } from 'react-i18next'
import RadioInput from '../../../components/inputs/RadioInput'

interface ContractTypeSelectProps {
	value: string | undefined
	onChange: (companyName: string) => void
}

/**
 * ContractTypeSelect component allows users to select electricity contract type.
 *
 * @param {ContractTypeSelectProps} props - The props for the component.
 * @returns {JSX.Element} The rendered component.
 */
const ContractTypeSelect: React.FC<ContractTypeSelectProps> = ({ value, onChange }) => {
	const { t } = useTranslation('pages_onboarding')
	const contractTypeOptions = [
		{
			label: t('contractTypeSlide.kiintea'),
			value: 'fixed',
		},
		{
			label: t('contractTypeSlide.porssi'),
			value: 'spot',
		},
	]

	return (
		<div className='input-container'>
			{contractTypeOptions.map((option, index) => (
				<RadioInput
					key={index}
					label={option.label}
					isChecked={value === option.value}
					onChange={() => onChange(option.value)}
					readonly={false}
				/>
			))}
		</div>
	)
}

export default ContractTypeSelect
